import { useEffect } from 'react';
import { ASSIGNMENT_VALIDATION_FIELDS } from 'utils/assignmentEditorConstants';
import { getAssignmentPublishErrors } from 'utils/assignmentSettingsValidation';

const useAssignmentEditorErrorReconciliation = ({ form, restrictions, setErrors }) => {
    useEffect(() => {
        if (!setErrors || !form) return;

        const validationErrors = getAssignmentPublishErrors(form, restrictions);
        setErrors((current) => {
            const resolvedFields = ASSIGNMENT_VALIDATION_FIELDS.map(({ field }) => field).filter(
                (field) => current?.[field] === true && !validationErrors[field]
            );
            if (!resolvedFields.length) return current;

            const next = { ...current };
            resolvedFields.forEach((field) => delete next[field]);
            return next;
        });
    }, [form, restrictions, setErrors]);
};

export default useAssignmentEditorErrorReconciliation;
